import { defineMessages } from 'react-intl';

export default defineMessages({
  people: {
    id: 'cboard.components.Settings.People.people',
    defaultMessage: 'People'
  },
  name: {
    id: 'cboard.components.Settings.People.name',
    defaultMessage: 'Name'
  },
  nameSecondary: {
    id: 'cboard.components.Settings.People.nameSecondary',
    defaultMessage: 'Update your user name'
  },
  email: {
    id: 'cboard.components.Settings.People.email',
    defaultMessage: 'Email'
  },
  emailSecondary: {
    id: 'cboard.components.Settings.People.emailSecondary',
    defaultMessage: 'Update your user email'
  },
  language: {
    id: 'cboard.components.Settings.People.language',
    defaultMessage: 'Language'
  },
  languageSecondary: {
    id: 'cboard.components.Settings.People.languageSecondary',
    defaultMessage: 'Let us know what is your language'
  },
  birthdate: {
    id: 'cboard.components.Settings.People.birthdate',
    defaultMessage: 'Birth Date'
  },
  birthdateSecondary: {
    id: 'cboard.components.Settings.People.birthdateSecondary',
    defaultMessage: 'Update your birth date'
  },
  logout: {
    id: 'cboard.components.Settings.People.logout',
    defaultMessage: 'Logout'
  }
});
